import React from 'react';
import T from '@prisjakt/ui-translate';
import MissingShop from '../../missing-shop';
import { Price, User } from '../../../../../types';
import * as S from '../styles';

const PriceListHeaderTitle: React.FC<IPriceListHeaderProps> = props => {
  const { sortedPrices, me } = props;

  return (
    <S.OnlyDesktop data-test="PricePanelHeader">
      <T domain="product" product="prices.title">
        prices.title
      </T>
      &nbsp;
      <S.TitleCount>
        (
        <T
          domain="product"
          product="prices.title-offers-count"
          n={sortedPrices?.length || 0}
        >
          prices.title-offers-count
        </T>
        )
      </S.TitleCount>
      {me?.analyticsAccess?.stores && <MissingShop />}
    </S.OnlyDesktop>
  );
};

interface IPriceListHeaderProps {
  sortedPrices: Price[] | null | undefined;
  me: User;
}

export default PriceListHeaderTitle;
